import React from "react";
import SocialLink from "./link-item";
import { Column, Row, Section } from "@react-email/components";
import { fetchSocialItems } from "@/utils/constants";

const SocialLinks = ({ user }) => {
  const socialItems = fetchSocialItems(user);

  if (socialItems.length === 0) return null;

  return (
    <Section className="border-t border-gray-500 border-solid">
      <Row>
        {socialItems.map((item, index) => {
          return (
            <Column
              key={item.id}
              className={`text-center h-12   ${
                index !== 0 && index !== socialItems.length
                  ? "border-0 border-l border-l-gray-500 border-solid font-semibold"
                  : ""
              }`}
              style={{ width: `${100 / socialItems.length}%` }}
            >
              <SocialLink item={item} />
            </Column>
          );
        })}
      </Row>
    </Section>
  );
};

export default SocialLinks;
